module.exports = __webpack_public_path__ + "img/MC.ae3b9334.svg";